import React from "react";
import { SectionHeader } from "../components/section-header";
import { SectionLoader } from "../components/section-loader";
import { EmptyState } from "@/components/shared/empty-state";
import { TrendingUp } from "lucide-react";
import { EditorialCard } from "../components/editorial-card";
import type { HomepageArticle } from "@/components/homepage/types";
import Link from "next/link";
import { Button } from "@/components/ui/button";

interface TodayHighlightsSectionProps {
  items: HomepageArticle[];
  isLoading: boolean;
}

export function TodayHighlightsSection({ items, isLoading }: TodayHighlightsSectionProps) {
  const displayItems = items.length > 0 ? items.slice(0, 6) : [];

  return (
    <section aria-labelledby="today-highlights-heading">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <SectionHeader
          eyebrow="Today"
          icon={TrendingUp}
          title="Today's Highlights"
          href="/discover"
        />
        {isLoading ? (
          <SectionLoader variant="grid" count={6} />
        ) : displayItems.length > 0 ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {displayItems.map((item) => (
              <EditorialCard
                key={item.id}
                title={item.title}
                description={typeof item.content === "string" ? item.content.slice(0, 120) : ""}
                author={item.author}
                readTime={item.readTime}
                category={item.category ?? "News"}
                date={item.createdAt}
                href={`/news/${item.id}`}
                variant="default"
                tags={item.tags}
              />
            ))}
          </div>
        ) : (
          <EmptyState icon={TrendingUp} description="No highlights available yet." action={<Button variant="outline" size="sm" asChild><Link href="/discover">Browse all content</Link></Button>} />
        )}
      </div>
    </section>
  );
}